var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mr-1",attrs:{"small":"","icon":""},on:{"click":_vm.navBack}},[_c('v-icon',{attrs:{"color":_vm.toolbarIconColor,"size":_vm.toolbarIconSize}},[_vm._v("mdi-arrow-left")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }